import React from 'react';
import { PropTypes } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const BoxInputDotDivider = ({
  width,
  height,
  radius,
  strokeColor
}) => (
  <svg
    width={ width }
    height={ height }
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx={ width / 2 }
      cy={ height - 3 }
      r={ radius }
      stroke={ strokeColor }
    />
  </svg>
);

BoxInputDotDivider.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  radius: PropTypes.number,
  strokeColor: PropTypes.string
};

BoxInputDotDivider.defaultProps = {
  width: 82,
  height: 34,
  radius: 2,
  strokeColor: '#000'
};
